/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Franchise_Self_ManagedInputs */

const cs_franchise_self_managed = /** @type {(inputs: Franchise_Self_ManagedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vlastní předplatné`)
};

const en_franchise_self_managed = /** @type {(inputs: Franchise_Self_ManagedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Self-managed subscription`)
};

/**
* | output |
* | --- |
* | "Self-managed subscription" |
*
* @param {Franchise_Self_ManagedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const franchise_self_managed = /** @type {((inputs?: Franchise_Self_ManagedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Franchise_Self_ManagedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_franchise_self_managed(inputs)
	return cs_franchise_self_managed(inputs)
});